import lenis from './lenis'
import gsap from 'gsap'
import { markInitialised, setExpanded } from '../utils/dom'

let activeNavContext = null
let documentKeydownBound = false

export default function initNavMenu() {

	let navMenu = document.querySelector("[data-nav-menu]")
	if (!navMenu) {
		activeNavContext = null
		return
	}

	let container = navMenu.querySelector("[data-nav-container]")
	let menuToggles = document.querySelectorAll("[data-nav-toggle]")
	let logo = navMenu.querySelectorAll("[data-nav-logo]")
	let fadeInItems = navMenu.querySelectorAll("[data-nav-fade]")
	let lastTrigger = null

	if (!container || !markInitialised(navMenu, 'jsNavMenu')) {
		return
	}

	let tl = gsap.timeline()

	const setToggleState = (isOpen) => {
		menuToggles.forEach((toggle) => setExpanded(toggle, isOpen))
		navMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true')
	}

	const openNav = (trigger = null) => {
		if (navMenu.getAttribute("data-nav-state") === "open") return

		lastTrigger = trigger
		navMenu.setAttribute("data-nav-state", "open")
		setToggleState(true)
		lenis.stop()

		tl.clear()
			.set(navMenu, { display: "block" })
			.fromTo(container, { clipPath: 'inset(0px 0% 100% 0px)' }, { clipPath: 'inset(0px 0% 0% 0px)', duration: 1, ease: "power4.inOut" })
			.fromTo(logo, { opacity: 0 }, { opacity: 1, duration: 0.4, stagger: 0.05, ease: 'sine.out' }, "<+=0.4")
			.fromTo(fadeInItems, { yPercent: 70, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.6, stagger: 0.05, ease: 'power2.out' }, "<+=0.05")
			.call(() => {
				const firstLink = navMenu.querySelector('a[href], button:not([data-nav-toggle])')
				firstLink?.focus({ preventScroll: true })
			})
	}

	const closeNav = () => {
		if (navMenu.getAttribute("data-nav-state") !== "open") return

		navMenu.setAttribute("data-nav-state", "closed")
		setToggleState(false)

		tl.clear()
			.to(fadeInItems, { yPercent: 70, opacity: 0, duration: 0.6, stagger: -0.05, ease: 'power2.in' })
			.to(container, { clipPath: 'inset(0px 0% 100% 0px)', duration: 1, ease: "power4.inOut" }, "<+=0.4")
			.to(logo, { opacity: 0, duration: 0.4, ease: 'sine.in' }, "<+=0.35")
			.set(navMenu, {
				display: "none",
				onComplete: () => {
					lenis.start()
					lastTrigger?.focus({ preventScroll: true })
				}
			})
	}

	// Toggle menu open / close depending on its current state
	menuToggles.forEach((toggle) => {
		toggle.addEventListener("click", () => {
			const state = navMenu.getAttribute("data-nav-state")
			const action = toggle.getAttribute('data-nav-toggle')

			if (action === 'close') {
				closeNav()
				return
			}

			if (state === "open") {
				closeNav()
			} else {
				openNav(toggle)
			}
		})
	})

	activeNavContext = {
		closeNav,
	}

	// If menu is open, you can close it using the "escape" key
	if (!documentKeydownBound) {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") {
				activeNavContext?.closeNav()
			}
		})
		documentKeydownBound = true
	}

	setToggleState(navMenu.getAttribute("data-nav-state") === "open")
}
